import React from 'react';

const PageHeader = ({ headerText, surveyName, mode }) => {
  const headerString = headerText ? ": " : "";
  
  return (
    <div className="questionsHeader">
      <div className="logo"></div>
      <div className="headerText">
        {headerText}
        {headerString}
        {surveyName}
      </div>
      {mode === 'preview' && (
        <div className="modeInformation">Vorschau</div>
      )}
      {mode === 'debug' && (
        <div className="modeInformation">DebugMode</div>
      )}
    </div>
  );
};

export default PageHeader;
